import { createAction, props } from '@ngrx/store';
import { DeliveryZoneCustomer, DeliveryZoneCustomerForm } from '@core/models'
import { IResponseBadRequest } from '@core/interfaces';

export const DELIVERY_ZONE_CUSTOMER_FIND = createAction('[deliveryZoneCustomer] Find', props<{ id: string }>());
export const DELIVERY_ZONE_CUSTOMER_FIND_ALL = createAction('[deliveryZoneCustomer] Find All');

export const DELIVERY_ZONE_CUSTOMER_FIND_SUCCESS = createAction('[deliveryZoneCustomer] Find Success', props<{ deliveryZoneCustomer: DeliveryZoneCustomer }>());
export const DELIVERY_ZONE_CUSTOMER_FIND_ALL_SUCCESS = createAction('[deliveryZoneCustomer] Find All Success', props<{ deliveryZoneCustomerList: DeliveryZoneCustomer[] }>());

export const DELIVERY_ZONE_CUSTOMER_FAILURE = createAction('[deliveryZoneCustomer] Failure', props<{ error: IResponseBadRequest }>());

export const DELIVERY_ZONE_CUSTOMER_UPDATE_LOADING = createAction('[deliveryZoneCustomer] Update Loading', props<{ loading: boolean }>());

export const DELIVERY_ZONE_CUSTOMER_UPDATE_FORM = createAction('[deliveryZoneCustomer] Update Form', props<{ deliveryZoneCustomerForm: DeliveryZoneCustomerForm }>());

export const DELIVERY_ZONE_CUSTOMER_EDIT_MODE = createAction('[deliveryZoneCustomer] Edit Mode', props<{ editMode: boolean }>());

export const DELIVERY_ZONE_CUSTOMER_RESET = createAction('[deliveryZoneCustomer] Reset');

export const DELIVERY_ZONE_CUSTOMER_RESET_FORM = createAction('[deliveryZoneCustomer] Reset Form');

export const DELIVERY_ZONE_CUSTOMER_RESET_ERROR = createAction('[deliveryZoneCustomer] Reset Error');

export const DELIVERY_ZONE_CUSTOMER_UPDATE_VIEW = createAction('[deliveryZoneCustomer] Update IView', props<{ deliveryZoneCustomerId: string }>());

export const DELIVERY_ZONE_CUSTOMER_REMOVE = createAction('[deliveryZoneCustomer] Remove', props<{ id: string }>());

export const DELIVERY_ZONE_CUSTOMER_REMOVE_COMPLETED = createAction('[deliveryZoneCustomer] Remove completed');

export const DELIVERY_ZONE_CUSTOMER_CLEAR_STATE = createAction('[deliveryZoneCustomer] Clear state');

export const DELIVERY_ZONE_CUSTOMER_FIND_FORM_SUCCESS = createAction('[deliveryZoneCustomer] Find Form Success', props<{ deliveryZoneCustomerForm: DeliveryZoneCustomerForm }>());

export const DELIVERY_ZONE_CUSTOMER_CREATE = createAction('[deliveryZoneCustomer] Create');

export const DELIVERY_ZONE_CUSTOMER_UPDATE = createAction('[deliveryZoneCustomer] Update');

export const DELIVERY_ZONE_CUSTOMER_UPDATE_ID = createAction('[deliveryZoneCustomer] Update Id',props<{ deliveryZoneCustomerId: string }>());

